let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("58UdM"), load("4Qstt"), load("5odbj"), load("affRy"), load("5zDuS"), load("i5Fj1"), load("fJjZJ")]).then(() => parcelRequire('8d4o6'));